const urlFoodRandom = 'https://www.themealdb.com/api/json/v1/1/random.php';
const urlDrinkRandom = 'https://www.thecocktaildb.com/api/json/v1/1/random.php';

export const fecthIdFoodRandom = async () => {
  const data = await fetch(urlFoodRandom)
    .then((response) => response.json());

  return data.meals[0].idMeal;
};

export const fecthIdDrinkRandom = async () => {
  const data = await fetch(urlDrinkRandom)
    .then((response) => response.json());

  return data.drinks[0].idDrink;
};
